/**
 *
 * App.js
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 *
 */
import "./base.less"
import "./index.less"
import "./animations.less"
import "moment/locale/es-us"
import "../../utils/catchError"
import "../../utils/global-fetch-api"
import "./override-antd.less"

import {
  AMBASSADOR_USERS,
  COMPARATIVE_ANALYSIS,
  COMPARATIVE_ANALYSIS_TEAM,
  CONTROL_PANEL,
  DASHBOARD,
  EXPORTABLES,
  IDLE_TIME,
  LEADER_USERS,
  MEASURES,
  ORGANIZATION,
  REPORTS,
  RESULT_BY_DIMENSION,
  RESULT_BY_DIVISION,
  RESULT_BY_TEAM,
  ROLES_ADMIN,
  SAVING_LOG_TIME,
  SURVEYS,
  SYNCHRONIZATION_ERRORS,
  TRACING,
} from "../../utils/constants"
import { Redirect, Route, Switch, withRouter } from "react-router-dom"

/* Action Plans */
import ActionPlans from "../ActionPlans"
import AdministratorCompaniesForm from "../Administrator/Companies/Form"
/* Administrator Mandü */
import AdministratorCompaniesHome from "../Administrator/Companies/Home"
import AdministratorUsersHome from "../Administrator/Users/Home"
import AmbassadorsImport from "../AmbassadorsImport"
import AmbassadorsSummary from "../AmbassadorsSummary"
import CollaboratorsCreate from "../CollaboratorsCreate"
import CollaboratorsEdit from "../CollaboratorsEdit"
import CollaboratorsImport from "../CollaboratorsImport"
import CollaboratorsSummary from "../CollaboratorsSummary"
import ControlPanel from "../ControlPanel/Home"
import DashboardAdministrator from "../Dashboard/Administrator"
import DashboardAmbassador from "../Dashboard/Ambassador"
import DashboardLeader from "../Dashboard/Leader"
import DivisionEdit from "../DivisionEdit"
import DivisionsImport from "../DivisionsImport"
import DivisionsSummary from "../ImportDivisionsContainer"
import ForgottenPassword from "../ForgottenPassword"
import Support from "../Support"
import GenericNotFound from "../../components/GenericNotFound"
/* User time handle */
import IdleTimer from "react-idle-timer"
import LeadersImport from "../LeadersImport"
import LeadersSummary from "../LeadersSummary"
import Login from "containers/Login"
import MeasurementCreate from "../MeasurementCreate/Home"
import MeasurementNew from "../MeasurementCreate/NewHome"
import MeasurementDetails from "../MeasurementDetails"
import MeasurementHistory from "../MeasurementHistory"
import MeasurementQualitatives from "../MeasurementDetails/MeasurementQualitatives"
import ModalFreemiumAlertDaysRemaining from "components/ModalFreemiumAlertDaysRemaining"
import MeasurementImportRecipients from "../MeasurementImportRecipients"
import MeasurementRecipientsSummary from "../MeasurementImportRecipientsSummary"

import MyAccount from "../MyAccount"
import OrganizagtionPage from "../OrganizationPage"
import PrivateRoute from "../../components/PrivateRoute"
import PrivateRouteAccess from "../../components/PrivateRouteAccess"
import ProfileAmbassador from "../ProfileAmbassador"
import ProfileLeader from "../ProfileLeader"
import React from "react"
import ReportDashboard from "../ReportsDashboard"
import ReportExport from "../Report/ReportExport"

import ReportsComparativeAnalysis from "../Reports/ComparativeAnalysis"
import ReportsDimensionByDivision from "../Reports/DimensionByDivision"
import ReportsDimensionByTeam from "../Reports/DimensionByTeam"
/* Reports */
import ReportsDivisionAnalysis from "../Reports/DivisionAnalysis"
import ReportsQualitativeQuestion from "../Reports/QualitativeQuestion"
import ReportsSentimentAnalysis from "../Reports/SentimentAnalysis"
import ReportsMultipleChoiceQuestion from "../Reports/MultipleChoiceQuestion"
import ReportsTeamAnalysis from "../Reports/TeamAnalysis"
import RestorePassword from "../RestorePassword"
import SetPassword from "../SetPassword"
import Survey from "../Survey"
import Surveys from "../Surveys"
import SurveysImport from "../SurveysImport"
import Version from "../Version"
import moment from "moment"
import { Reports } from "../../Reports"
import { ReportsV2 } from "../../ReportsV2"
import ActionPlansImport from "../ActionPlansImport"
import ActionPlansImportSummary from "../ActionPlansImportSummary"
import TwoFactorAuth from "../TwoFactorAuth"
import SynchronizationErrors from "../ControlPanel/SynchronizationErrors"
import useFreshchatDarkMode from "../../hooks/useFreshchatDarkMode"

/* End Reports */

moment.locale("es-us")

class App extends React.Component {
  constructor(props) {
    super(props)
    this.currentTime = Date.now()
    this.idleTimer = null
    this.onActive = this._onActive.bind(this)
    this.onIdle = this._onIdle.bind(this)
    this.savingLog = this.savingLog.bind(this)

    this.interval = setInterval(this.savingLog, 1000 * 60 * SAVING_LOG_TIME)
  }

  componentDidUpdate(prevProps) {
    // NOTE: in order to have access to this information, you will need
    // to wrap this component in the `withRouter` HOC
    const {
      location: { pathname },
    } = this.props
    const previousLocation = prevProps.location.pathname
    
   
  }

  render() {
    let showDashboard = DashboardAdministrator
    if (validRole({ role: [5] })) {
      showDashboard = DashboardAmbassador
    }
    if (validRole({ role: [6] })) {
      showDashboard = DashboardLeader
    }
    
    return (
      <div>
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref
          }}
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          debounce={250}
          timeout={1000 * 60 * IDLE_TIME}
        />
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/transfer/:hash" component={Login} />
          <PrivateRouteAccess
            slug={DASHBOARD}
            exact
            path="/"
            component={showDashboard}
          />
          <Route
            exact
            path="/forgottenPassword"
            component={ForgottenPassword}
          />
          <Route
            exact
            path="/password-reset/:token/:email"
            component={RestorePassword}
          />
          <Route
            exact
            path="/password-set/:token/:email"
            component={SetPassword}
          />

          <Route
            exact
            path="/two_factor_authentication"
            component={TwoFactorAuth}
          />

          <PrivateRouteAccess
            slug={ORGANIZATION}
            exact
            path="/organization"
            component={OrganizagtionPage}
          />
          <PrivateRouteAccess
            slug={ORGANIZATION}
            exact
            path="/organization/divisions/summary"
            component={DivisionsSummary}
          />
          <PrivateRouteAccess
            slug={ORGANIZATION}
            exact
            path="/organization/divisions/import"
            component={DivisionsImport}
          />
          <PrivateRouteAccess
            slug={ORGANIZATION}
            exact
            path="/organization/division/edit/:id"
            component={DivisionEdit}
          />

          <PrivateRouteAccess
            slug={ORGANIZATION}
            exact
            path="/organization/collaborators/summary"
            component={CollaboratorsSummary}
          />
          <PrivateRouteAccess
            slug={ORGANIZATION}
            exact
            path="/organization/collaborators/import"
            component={CollaboratorsImport}
          />
          <PrivateRouteAccess
            slug={ORGANIZATION}
            exact
            path="/organization/collaborators/create"
            component={CollaboratorsCreate}
          />
          <PrivateRouteAccess
            slug={ORGANIZATION}
            exact
            path="/organization/collaborators/edit/:id"
            component={CollaboratorsEdit}
          />

          <PrivateRouteAccess
            slug={SURVEYS}
            exact
            path="/models/surveys"
            component={Surveys}
          />
          <PrivateRouteAccess
            slug={SURVEYS}
            exact
            path="/models/surveys/import/:id"
            component={SurveysImport}
          />
          <PrivateRouteAccess
            slug={SURVEYS}
            exact
            path="/models/surveys/:id"
            component={Survey}
          />

          <PrivateRouteAccess
            slug={MEASURES}
            exact
            path="/models/measure-history"
            component={MeasurementHistory}
          />
          <PrivateRouteAccess
            slug={MEASURES}
            exact
            path="/models/measure-create/:id"
            component={MeasurementCreate}
          />
          <PrivateRouteAccess
            slug={MEASURES}
            exact
            path="/models/measure-new"
            component={MeasurementNew}
          />
          <PrivateRouteAccess
            slug={MEASURES}
            exact
            path="/models/measure/:id"
            component={MeasurementDetails}
          />
          <PrivateRouteAccess
            slug={MEASURES}
            exact
            path="/models/measure/:id/import-recipients/"
            component={MeasurementImportRecipients}
          />
          <PrivateRouteAccess
            access={{ role: [1, 2, 3, 4] }}
            exact
            path="/models/measure/:id/import-recipients/summary"
            component={MeasurementRecipientsSummary}
          />
          <PrivateRouteAccess
            access={{ role: [1, 2, 3, 4] }}
            exact
            path="/models/measure/:id/qualitative-question"
            component={MeasurementQualitatives}
          />

          <PrivateRouteAccess
            slug={CONTROL_PANEL}
            access={{ role: [1, 2, 3, 4] }}
            exact
            path="/control-panel/:module?/:id?"
            component={ControlPanel}
          />

          <PrivateRouteAccess
            slug={SYNCHRONIZATION_ERRORS}
            access={{ role: [1, 2, 3, 4] }}
            exact
            path="/synchronization-errors/:id"
            component={SynchronizationErrors}
          />

          <PrivateRoute exact path="/my-account" component={MyAccount} />

          <PrivateRouteAccess
            slug={REPORTS}
            exact
            path="/reports"
            component={ReportsV2}
          />

          <PrivateRouteAccess
            slug={REPORTS}
            exact
            path="/reports/dashboard"
            component={ReportDashboard}
          />

          <PrivateRouteAccess
            exact
            path="/reports/export"
            component={ReportExport}
          />
          <PrivateRouteAccess
            exact
            path="/reports/export/measure/:id"
            component={ReportExport}
            validateMode
            slug={EXPORTABLES}
          />
          <PrivateRoute
            exact
            path="/reports/export/measure/:id/:nameView"
            component={ReportExport}
            validateMode
            slug={EXPORTABLES}
          />

          <PrivateRouteAccess
            slug={RESULT_BY_DIVISION}
            validateMode
            exact
            path="/reports/measure/:id/divisions"
            component={ReportsDivisionAnalysis}
          />
          <PrivateRouteAccess
            slug={RESULT_BY_DIMENSION}
            validateMode
            exact
            path="/reports/measure/:id/divisions/:idDivision/dimensions"
            component={ReportsDimensionByDivision}
          />
          <PrivateRoute
            slug={COMPARATIVE_ANALYSIS}
            validateMode
            exact
            path="/reports/measure/:id/analysis-comparative"
            component={ReportsComparativeAnalysis}
          />
          <PrivateRoute
            exact
            validateMode
            path="/reports/measure/:id/qualitative-question"
            component={ReportsQualitativeQuestion}
          />
          <PrivateRoute
            exact
            validateMode
            path="/reports/measure/:id/sentiment-analysis"
            component={ReportsSentimentAnalysis}
          />
          <PrivateRoute
            exact
            validateMode
            path="/reports/measure/:id/multiple-choice-question"
            component={ReportsMultipleChoiceQuestion}
          />

          {/* Reportes por equipo */}
          <PrivateRoute
            exact
            path="/reports/measure/:id/teams"
            component={ReportsTeamAnalysis}
          />
          <PrivateRouteAccess
            slug={COMPARATIVE_ANALYSIS_TEAM}
            validateMode
            exact
            path="/reports/measure/:id/teams/analysis-comparative"
            component={ReportsComparativeAnalysis}
          />
          <PrivateRouteAccess
            slug={RESULT_BY_TEAM}
            validateMode
            exact
            path="/reports/measure/:id/teams/:idDivision/dimensions"
            component={ReportsDimensionByTeam}
          />

          <PrivateRouteAccess
            slug={REPORTS}
            exact
            path="/reports/measure/:id_measure"
            component={ReportsV2}
          />

          <PrivateRouteAccess
            slug={REPORTS}
            exact
            path="/reports/measure/:id_survey_type/:id_measure"
            component={ReportsV2}
          />

          <PrivateRouteAccess
            slug={REPORTS}
            exact
            path="/reports/measure/:id_survey_type/:id_measure"
            component={ReportsV2}
          />

          <PrivateRouteAccess
            access={{
              role: [3, 4],
            }}
            exact
            path="/companies"
            component={AdministratorCompaniesHome}
          />
          <PrivateRouteAccess
            access={{
              role: [3, 4],
            }}
            exact
            path="/companies/:id"
            component={AdministratorCompaniesForm}
          />
          <PrivateRouteAccess
            access={{
              role: [3],
            }}
            exact
            path="/users"
            component={AdministratorUsersHome}
          />
          <PrivateRouteAccess
            access={{
              role: [7],
            }}
            exact
            path="/support"
            component={Support}
          />

          <PrivateRoute exact path="/version" component={Version} />
          <Redirect
            from="/organization/divisions"
            to="/organization#divisions"
          />
          <Redirect
            from="/organization/collaborators"
            to="/organization#collaborators"
          />

          <PrivateRouteAccess
            access={{
              role: [1, 2, 3, 4, 5],
            }}
            slug={TRACING}
            validateMode
            exact
            path="/action-plans"
            component={ActionPlans}
          />

          <PrivateRouteAccess
            access={{
              role: ROLES_ADMIN,
            }}
            slug={TRACING}
            validateMode
            exact
            path="/action-plans/import/:id_measure"
            component={ActionPlansImport}
          />

          <PrivateRouteAccess
            access={{
              role: ROLES_ADMIN,
            }}
            slug={TRACING}
            validateMode
            exact
            path="/action-plans/import/:id_measure/summary"
            component={ActionPlansImportSummary}
          />

          <PrivateRouteAccess
            slug={AMBASSADOR_USERS}
            access={{
              role: [1, 2, 3, 4],
            }}
            exact
            path="/ambassador/import"
            component={AmbassadorsImport}
          />
          <PrivateRouteAccess
            slug={AMBASSADOR_USERS}
            access={{
              role: [1, 2, 3, 4],
            }}
            exact
            path="/ambassador/import/summary"
            component={AmbassadorsSummary}
          />
          <PrivateRouteAccess
            access={{ role: [1, 2, 3, 4, 5, 6] }}
            exact
            path="/ambassador/:id"
            component={ProfileAmbassador}
          />
          <PrivateRouteAccess
            slug={LEADER_USERS}
            access={{ role: [1, 2, 3, 4] }}
            exact
            path="/leaders/import"
            component={LeadersImport}
          />
          <PrivateRouteAccess
            slug={LEADER_USERS}
            access={{ role: [1, 2, 3, 4] }}
            exact
            path="/leaders/import/summary"
            component={LeadersSummary}
          />
          <PrivateRouteAccess
            access={{ role: [1, 2, 3, 4, 5, 6] }}
            exact
            path="/leader/:id"
            component={ProfileLeader}
          />

          <Route component={GenericNotFound} />
        </Switch>
        {validRole({ role: [1, 2, 3, 4] }) && (
          <ModalFreemiumAlertDaysRemaining />
        )}
      </div>
    )
  }

  savingLog(ini) {
    // Save activity log
    /* createActivityLogApi({
      user_id: LOCAL_USER_ID(),
      duration: SAVING_LOG_TIME,
    }) */
  }

  // On reactive keyboard or mouse
  _onActive(e) {
    this.interval = setInterval(this.savingLog, 1000 * 60 * SAVING_LOG_TIME)
  }

  // On Iddle Time
  _onIdle(e) {
    if (this.interval) {
      clearInterval(this.interval)
    }
    // Remove activity log
    /* createActivityLogApi({
      user_id: LOCAL_USER_ID(),
      duration: -1 * IDLE_TIME,
    }) */
  }
}

export default withRouter(App)
